<template>
    <div>
        <PageHeader :title="'Videos'" :heroImg="'/images/heroes/videos.webp'" />
        <section class="py-8 md:py-16 bg-dark-grey">
            <div class="max-w-2xl mx-auto px-6">
                <div v-if="loading" class="text-center text-white py-12">
                    Loading videos&hellip;
                </div>
                <div v-else-if="!videos.length" class="text-center text-white py-12">
                    No videos available.
                </div>
                <div
                    v-else
                    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8"
                >
                    <VideoItem
                        v-for="video in videos"
                        :key="video.id"
                        :title="video.title"
                        :src="video.src"
                        :thumbnail="video.thumb"
                        :is_embed="!!video.is_embed"
                    />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import PageHeader from "@c/PageHeader.vue";
import VideoItem from "@c/pages/sales-tools/VideoItem.vue";
import axios from "axios";

export default {
    name: "VideosNew",
    components: { PageHeader, VideoItem },
    data() {
        return {
            videos: [],
            loading: true,
        };
    },
    mounted() {
        axios
            .get("/api/videos")
            .then((response) => {
                this.videos = response.data || [];
            })
            .catch(() => {
                this.videos = [];
            })
            .finally(() => {
                this.loading = false;
            });
    },
};
</script>
